import { useCallback, ReactNode } from 'react';
import { useAuth0, Auth0Provider as Provider } from '@auth0/auth0-react';
import { Button } from 'antd';

export default function Auth0SSO() {
  const { loginWithRedirect, isLoading } = useAuth0();
  const signIn = useCallback(() => loginWithRedirect(), [loginWithRedirect]);
  return (
    <Button
      type='primary'
      onClick={signIn}
      size='large'
      loading={isLoading}
    >
      {isLoading ? 'Connexion…' : 'Se connecter'}
    </Button>
  );
}

interface Auth0ProviderProps {
  children: ReactNode,
}
export function Auth0Provider({ children } : Auth0ProviderProps) {
  return (
    <Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN || ''}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || ''}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/sign-in`,
      }}
    >
      {children}
    </Provider>
  );
}
